<template>
  <section class="rows">
    <div class="container">
      <div class="content reporting-row">
        <div class=" container form-group col-lg-5">
          <label>Villes</label>
          <select v-on:change="changedSelect()"
                  v-model="selectedVille"
                  class="form-control demande-filters"
                  id="ville"
          >
            <option value="0">Sélectionner une ville</option>
            <option
              v-for="ville in villes.availableVilles"
              v-bind:value="ville"
              v-bind:item="selectedVille"
              v-bind:key="ville.id"
            >
              {{ ville.nom }}
            </option>
          </select>
        </div>
        <div class="col-sm-2 pull-right">
          <label>&nbsp;</label>
          <button
            type="button"
            v-on:click="saveModifications()"
            class="btn btn-block save-btn"
          >
            Sauvegarder
          </button>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="row" v-for="mod in selectedVille && selectedVille.parametragebos" :key="mod.nom">
        <div class="col-md-8">
          <span class="title-item">Module</span>
          <span class="text-item">{{ mod.libelle }}</span>
        </div>
        <div class="col-md-2">
          <span class="title-item">Actif ?</span>
          <input type="checkbox" v-model="mod.actif" class="big-checkbox text-item">
        </div>
      </div>
      <!--      <div class="row" v-if="selectedVille.module_android != undefined">
            <div class="col-md-8">
              <span class="title-item">Module</span>
              <span class="text-item">{{selectedVille.module_android.sms_multiple[0].label}}</span>
            </div>
            <div class="col-md-2">
              <span class="title-item">Actif ?</span>
              <input type="checkbox" v-model="selectedVille.module_android.sms_multiple[0].actif" class="big-checkbox text-item">
            </div>
            </div>-->
    </div>
  </section>
</template>

<script>
import {mapState} from 'vuex'
import Treeselect from '@riophae/vue-treeselect'

export default {
  components: {Treeselect},
  computed: {
    ...mapState([
      'villes',
    ]),
  },
  data: function () {
    return {
      selectedModules: [],
      selectedVille: '0',
      modules: []
    }
  },
  mounted: function () {
    this.$store.dispatch('fetchAllVilles')
  },
  methods: {
    saveModifications: function () {
      console.log('selected ville => ', this.selectedVille.id)
      this.$store.dispatch('updateModulesOfVille', {selectedVille: this.selectedVille, module: 'BO'})
    },
    changedSelect: function () {
      if (this.selectedVille.parametragebos) {
        const index = this.$store.state.villes.data.map(item => item.id).indexOf(this.selectedVille.id)
        this.$store.state.villes.availableVilles[index].parametragebos = _.cloneDeep(this.$store.state.villes.data[index].parametragebos)
      }

    }
  },
}
</script>

<style lang="scss">
@import '../../../scss/variables';

.row.reporting-row {
  align-items: start;
}

.content {
  min-height: 120px
}

button.save-btn {
  background-color: $suez-blue;
  background-repeat: no-repeat;
  background-position: 15px center;
  color: white;
  font-size: 14px;
  font-weight: bold;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
  border: none;
  padding: 7px 15px 8px 20px;
}

.big-checkbox {
  width: 20px;
  height: 20px;
}
</style>



// WEBPACK FOOTER //
// AdministrationBackoffice.vue?1fed9211